// extracted by mini-css-extract-plugin
export default {"faq":"abtasty-qa-assistant__HelperLink-module__faq___K7mzA"};